import { LocalStorage } from 'utils/localStorage';
import { UploadBulletinDraft, UploadBulletinStep } from 'components/bulletin-form/types';
import { PoiId } from 'utils/entities';

const LS_UPLOAD_BULLETIN_KEY = 'UPLOAD_BULLETIN_DRAFT';
const LS_WIZARD_CREATED_LISTING_KEY = 'UPLOAD_WIZARD_CREATED_LISTING';

export const uploadBulletinDraft: UploadBulletinDraft = {
  clear: () => LocalStorage.rm(LS_UPLOAD_BULLETIN_KEY),
  set: (val) => LocalStorage.set(LS_UPLOAD_BULLETIN_KEY, val),
  get: () => LocalStorage.get(LS_UPLOAD_BULLETIN_KEY),
};

export interface WizardCreatedListing {
  id: PoiId;
  type: 'bulletin' | 'commercialBulletin';
}

export const wizardCreatedListing = {
  clear: () => LocalStorage.rm(LS_WIZARD_CREATED_LISTING_KEY),
  set: (val: WizardCreatedListing) => LocalStorage.set(LS_WIZARD_CREATED_LISTING_KEY, val),
  get: (): WizardCreatedListing | null => LocalStorage.get(LS_WIZARD_CREATED_LISTING_KEY),
};

interface GetUploadStepsOptions {
  isEdit: boolean;
  isConnectedUser: boolean;
  isCommercial: boolean;
  isPrivateUser: boolean;
  isBasicPlan: boolean;
}

export const getUploadSteps = (options: GetUploadStepsOptions): UploadBulletinStep[] => {
  const { isEdit, isConnectedUser, isCommercial, isPrivateUser, isBasicPlan } = options;

  const steps = [
    (isEdit ? null : UploadBulletinStep.BulletinType),
    (isEdit ? UploadBulletinStep.DealType : null),
    UploadBulletinStep.Address,
    UploadBulletinStep.MainInfo,
    UploadBulletinStep.AdditionalInfo,
    (!isConnectedUser ? UploadBulletinStep.Authentication : null),
    UploadBulletinStep.UploadImage,
    UploadBulletinStep.Contacts,
    (isCommercial || !isPrivateUser ? UploadBulletinStep.Preview : null),
    (isEdit || isCommercial || (isPrivateUser && isCommercial) || !isBasicPlan ? null : UploadBulletinStep.PlanType),
  ];

  return steps.filter(Boolean);
};
